// tslint:disable
/**
 * API Studiestedbruker API
 * ALP api for Stuidestedbrukere
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: any;
}
export interface Api {
    fetch(method: string, url: string, queryParams: any, requestBody?: RequestBody, options?: any): Promise<any>;
}
export interface RequestBody {
    body: any;
    contentType: string;
}

export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

export class HttpError extends Error {
    readonly response: Response;
    readonly body: any;
    constructor(response: Response, body: any) {
        super(response.statusText);
        this.response = response;
        this.body = body;
        Object.setPrototypeOf(this, HttpError.prototype);
    }
}
export class ServerError extends HttpError {
    constructor(response: Response, body: any) {
        super(response, body);
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}
export class RequestError extends HttpError {
    constructor(response: Response, body: any) {
        super(response, body);
        Object.setPrototypeOf(this, RequestError.prototype);
    }
}
export class LoggedOutError extends RequestError {
    constructor(response: Response, body: any) {
        super(response, body);
        Object.setPrototypeOf(this, LoggedOutError.prototype);
    }
}
export class NotFoundError extends RequestError {
    constructor(response: Response, body: any) {
        super(response, body);
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    private basePath;
    private keepAlive;

    protected query(queryParams: any): string {
        return queryParams && Object.keys(queryParams).length ? ("?" + Object.keys(queryParams)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(queryParams[k]))
            .join('&')) : "";
    }
    protected createRequestBody(requestBody?: RequestBody): string|undefined {
        if (requestBody) {
            if (requestBody.contentType === "application/x-www-form-urlencoded") {
                const form:any = new FormData();
                let name:any = undefined;
                for (name in requestBody.body) {
                   form.append(name, requestBody.body[name]);
                }
                return new URLSearchParams(form).toString();
            } else {
                return JSON.stringify(requestBody.body);
            }
        }
    }
    protected async handleResponse(response: Response): Promise<any> {
        this.keepAlive()
        if (response.ok) {
            const contentType = response.headers.get("Content-type");
            if (contentType && contentType.startsWith("application/json")) {
                return response.json();
            }
            return;
        }
        const contentType: string | null = response.headers.get("content-type");
        const body: any = contentType != null && contentType.indexOf("application/json") == 0 && await response.json();
        if (response.status == 401) {
            window.location.href = window.location.origin + this.query({loggedOut: true});
            throw new LoggedOutError(response, body);
        } else if (response.status == 404) {
            throw new NotFoundError(response, body);
        } else if (response.status >= 500) {
            throw new ServerError(response, body);
        } else {
            throw new RequestError(response, body);
        }
    }
    protected path(pathTemplate: string, params: any): string {
        return pathTemplate.replace(/{(\w+)}/g, (match, g) => params[g]);
    }
    protected async GET(path: string, queryParams: any, requestBody?: RequestBody, options?: any) : Promise<any> {
        const result = await fetch(this.basePath + path + this.query(queryParams), {
            credentials: 'same-origin',
        });
        return await this.handleResponse(result);
    }
    protected async PUT(path: string, queryParams: any, requestBody?: RequestBody, options?: any) : Promise<any> {
        const headers:any = {};
        const body = this.createRequestBody(requestBody);
        if (requestBody) {
            headers['Content-Type'] = requestBody.contentType;
        }
        const result = await fetch(this.basePath + path + this.query(queryParams), {
            method: "PUT",
            credentials: 'same-origin',
            headers,
            body
        });
        return await this.handleResponse(result);
    }
    protected async POST(path: string, queryParams: any, requestBody?: RequestBody, options?: any) : Promise<any> {
        const headers:any = {};
        const body = this.createRequestBody(requestBody);
        if (requestBody) {
            headers['Content-Type'] = requestBody.contentType;
        }
        const result = await fetch(this.basePath + path + this.query(queryParams), {
            method: "POST",
            credentials: 'same-origin',
            headers,
            body
        });
        return await this.handleResponse(result);
    }
    protected async DELETE(path: string, queryParams: any, requestBody?: RequestBody, options?: any) : Promise<void> {
        const headers:any = {};
        const body = this.createRequestBody(requestBody);
        if (requestBody) {
            headers['Content-Type'] = requestBody.contentType;
        }
        const result = await fetch(this.basePath + path + this.query(queryParams), {
            method: "DELETE",
            credentials: 'same-origin',
            headers,
            body
        });
        return await this.handleResponse(result);
    }

    constructor(keepAlive: Function) {
        const server = "/studiestedapi";
        // @ts-ignore
        if (server === "/") {
            this.basePath = window.location.origin;
        } else if (server.startsWith("/")) {
            this.basePath = window.location.origin + server;
        } else {
            this.basePath = server;
        }

        this.keepAlive = keepAlive;
    }
}
